import axios from 'axios';
import { router } from '@/router';
import { store } from '@/store';
import {
  doGet,
  doPost,
  doPut,
} from '@/http';
import { http } from '@/providers/http.js';

const defaultUserState = () => {
  return {
    token: localStorage.getItem('token') || null,
    user: {},
    userLoaded: false,
    loggedIn: !!localStorage.getItem('token'),
  };
};

const state = defaultUserState();

const getters = {
  loggedIn: (state) => state.loggedIn,
  token: (state) => state.token,
  user: (state) => state.user,
  userLoaded: (state) => state.userLoaded,
};

const actions = {
  getUser: ({ commit }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/auth/user',
        method: 'GET',
      }).then(({ data }) => {
        commit('userFetched', data);

        resolve(data);
      }).catch(err => {
        reject(err);
      });
    });
  },
  getUserById: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `/api/get-user/${ id }`,
        method: 'GET',
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
  login: ({ dispatch, commit, state }, user) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/auth/login',
        data: user,
        method: 'POST',
      }).then(({ data }) => {
        commit('auth', data);

        resolve(data);
      }).catch(error => {
        commit('resetUserStore');

        reject(error);
      });
    });
  },
  changePassword: ({ commit }, requestData) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `/api/password`,
        method: 'PUT',
        data: requestData,
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
  forgotPassword: ({ commit }, requestData) => {
    return axios.post(`/api/auth/password/forgot`, requestData)
        .catch((err) => {
          // Explicitly rethrow to make sure mapActions treats it as an error
          throw err;
        });
  },
  resetPassword: ({ commit }, requestData) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `/api/auth/password/reset`,
        method: 'POST',
        data: requestData,
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
  validateToken: ({ commit }, token) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `/api/password/token`,
        method: 'POST',
        data: {
          token: token,
        },
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
  registerUser: ({ dispatch, commit, state }, user) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/api/auth/register/user',
        data: user,
        method: 'POST',
      }).then(({ data }) => {
        commit('auth', data);

        resolve(data);
      })
        .catch(error => {
          commit('resetUserStore');

          reject(error);
        });
    });
  },
  logout: ({ commit }) => {
    return new Promise((resolve, _) => {
      axios({
        url: '/api/auth/logout',
        method: 'POST',
      }).finally((_) => {
        commit('logoutSuccess');
      });
    });
  },
  updateProfile: ({ commit }, requestData) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `/api/update-user`,
        method: 'POST',
        data: requestData,
      }).then(({ data }) => {
        resolve(data);
      }).catch(err => reject(err));
    });
  },
};

const mutations = {
  auth: (state, data) => {
    state.token = data.access_token;
    state.loggedIn = true;

    localStorage.setItem('token', data.access_token);

    http.mount();
  },
  logoutSuccess: (state) => {
    Object.assign(state, defaultUserState());
    localStorage.clear();

    if (router.currentRoute.value.name !== 'public.login') {
      router.replace({ name: 'public.login' });
    }
  },

  userFetched: (state, user) => {
    state.user = user;
    state.userLoaded = true;
  },
  resetUserStore: (state) => {
    Object.assign(state, defaultUserState());
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
